import { ALERT, USER } from "../../constants";
import axios from "@helpers/axios/private.axios";

export const updateUser =
  ({ data }) =>
  async (dispatch) => {
    try {
      const resp = await axios.post("/users/update", {
        ...data,
      });

      if (resp.data?.data?.user) {
        const userPayload = {
          ...resp.data.data.user,
          full_name: resp.data.data.user.full_name || data.full_name,
          date_birth: resp.data.data.user.date_birth || data.date_birth,
        };
        
        if (userPayload.full_name) {
          localStorage.setItem('user_full_name', userPayload.full_name);
        }
        if (userPayload.date_birth) {
          localStorage.setItem('user_date_birth', userPayload.date_birth);
        }
        
        dispatch({ type: USER.USER_FIELD, payload: userPayload });
      } else if (resp.data?.data) {
        if (data.full_name) {
          localStorage.setItem('user_full_name', data.full_name);
        }
        if (data.date_birth) {
          localStorage.setItem('user_date_birth', data.date_birth);
        }
        dispatch({ type: USER.USER_FIELD, payload: resp.data.data });
      }

      return resp.data;
    } catch (e) {
      const { message } = e.response?.data || {};
      if (message) {
        dispatch({ type: ALERT.ALERT_ERROR, payload: message });
      }
      throw e;
    }
  };

export const updateUserKyc =
  ({ data }) =>
  async (dispatch) => {
    console.log(data);
    try {
      const resp = await axios.post("/kyc/start", {
        ...data,
      });

      return resp.data;
    } catch (e) {
      const { message } = e.response.data;
      dispatch({ type: ALERT.ALERT_ERROR, payload: message });
      throw e;
    }
  };
